// extracted by mini-css-extract-plugin
module.exports = {"customWrapper":"TournamentsComponent_customWrapper__11wl9"};